'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaTelegram } from "react-icons/fa";
import { SiThreads } from "react-icons/si";

// Default social media data array
const defaultSocialMediaData: SocialMediaItem[] = [{
  id: 1,
  icon: <FaFacebookF size={16} color="#1877F2" />,
  text: 'Facebook',
  href: 'https://www.facebook.com/DinamaniDaily'
}, {
  id: 2,
  icon: <FaTwitter size={16} color="#1DA1F2" />,
  text: 'Twitter',
  href: 'https://x.com/DinamaniDaily'
}, {
  id: 3,
  icon: <FaInstagram size={16} color="#E4405F" />,
  text: 'Instagram',
  href: 'https://www.instagram.com/dinamanidaily/'
}, {
  id: 4,
  icon: <FaTelegram size={16} color="#0088CC" />,
  text: 'Telegram',
  href: 'https://t.me/dinamaniofficial'
}, {
  id: 5,
  icon: <SiThreads size={16} color="#000000" />,
  text: 'Threads',
  href: '/'
}, {
  id: 6,
  icon: <FaYoutube size={16} color="#FF0000" />,
  text: 'YouTube',
  href: 'https://www.youtube.com/channel/UC3jcdpf8dWtljex9PyhSM6w'
}, {
  id: 7,
  icon: <div className="w-4 h-4 bg-gray-800 rounded flex items-center justify-center">
        <span className="text-white font-bold text-[8px]">GN</span>
      </div>,
  text: 'Google News',
  href: '/'
}];
interface SocialMediaItem {
  id: number;
  icon: React.ReactNode;
  text: string;
  href: string;
}
interface CustomSocialMedia {
  text: string;
  href: string;
}
interface SocialButtonProps {
  icon: React.ReactNode;
  text: string;
  href: string;
  onClick?: () => void;
  className?: string;
}
interface SocialMediaButtonsProps {
  socialMediaData?: CustomSocialMedia[];
  className?: string;
}
const SocialButton: React.FC<SocialButtonProps> = t0 => {
  const $ = _c(10);
  const {
    icon,
    text,
    href,
    onClick,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors ${className}`;
  let t3;
  if ($[0] !== icon) {
    t3 = <span className="flex-shrink-0">{icon}</span>;
    $[0] = icon;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== text) {
    t4 = <span className="text-sm font-medium text-gray-700">{text}</span>;
    $[2] = text;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== href || $[5] !== onClick || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} className={t2}>{t3}{t4}</a>;
    $[4] = href;
    $[5] = onClick;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
const SocialMediaButtons: React.FC<SocialMediaButtonsProps> = t0 => {
  const $ = _c(17);
  const {
    socialMediaData,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const handleSocialClick = _temp;
  let t2;
  if ($[0] !== socialMediaData) {
    t2 = () => {
      if (socialMediaData) {
        return socialMediaData.map(_temp2);
      }
      return defaultSocialMediaData;
    };
    $[0] = socialMediaData;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getSocialMediaItems = t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== className || $[3] !== getSocialMediaItems) {
    const itemsToRender = getSocialMediaItems();
    t5 = "p-3 sm:p-4 flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 sm:gap-0";
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <p className="text-12-tamil-700 text-020202 whitespace-nowrap">எங்களை பின்தொடரவும்</p>;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    t3 = `flex flex-wrap gap-2 sm:gap-3 justify-start sm:justify-end ${className}`;
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = item_0 => <SocialButton key={item_0.id} icon={item_0.icon} text={item_0.text} href={item_0.href} onClick={() => handleSocialClick(item_0.text)} />;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    t4 = itemsToRender.map(t7);
    $[2] = className;
    $[3] = getSocialMediaItems;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4) {
    t7 = <div className={t3}>{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default SocialMediaButtons;
function _temp(platform) {}
function _temp2(customItem, index) {
  const defaultItem = defaultSocialMediaData.find(item => item.text.toLowerCase() === customItem.text.toLowerCase());
  return {
    id: index + 1,
    icon: defaultItem?.icon || <div className="w-4 h-4 bg-gray-400 rounded flex items-center justify-center"><span className="text-white font-bold text-[8px]">{customItem.text.charAt(0).toUpperCase()}</span></div>,
    text: customItem.text,
    href: customItem.href
  };
}